import { render, staticRenderFns } from "./packages-compatibility.form.vue?vue&type=template&id=426f9e52&"
import script from "./packages-compatibility.form.vue?vue&type=script&lang=ts&"
export * from "./packages-compatibility.form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports